export default function isMobileRender() {
    const windowWidth = window.innerWidth;
    const match = navigator.userAgent.match(
        /(iPad)|(iPhone)|(iPod)|(android)|(Android)|(webOS)/i,
    );
    //Fix for iPad pro
    //TODO: find better solution
    if (windowWidth > 980 && match && match.includes('iPad')) return false;
    return !!match;
}
